import {
  drawer_start_styles_default
} from "./chunk.HD77HTLM.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/drawer/drawer-start.ts
var FadvDrawerStart = class extends s {
  constructor() {
    super(...arguments);
    this.isOpen = false;
  }
  open() {
    this.isOpen = true;
  }
  close() {
    this.isOpen = false;
  }
  render() {
    return $`<div class=${o({
      "drawer-start": true,
      "drawer-start--open": this.isOpen
    })} ><div class="drawer-start__logo"><slot name="logo"><img src="${this.logoSrc}" alt="${this.logoAlt}" /></slot></div><div class="drawer-start__content"><slot></slot></div></div>`;
  }
};
FadvDrawerStart.styles = drawer_start_styles_default;
__decorateClass([
  e({ attribute: "logo-src" })
], FadvDrawerStart.prototype, "logoSrc", 2);
__decorateClass([
  e({ attribute: "logo-alt" })
], FadvDrawerStart.prototype, "logoAlt", 2);
__decorateClass([
  t()
], FadvDrawerStart.prototype, "isOpen", 2);
FadvDrawerStart = __decorateClass([
  n("fadv-drawer-start")
], FadvDrawerStart);

export {
  FadvDrawerStart
};
